































































import Vue from 'vue'
import { Button, Circle, Notice } from 'view-design'
import { MediaUploadService } from '@/services'
import { UploadedFile } from '@/helper/interfaces'
import BaseIcon from '../svgicons/BaseIcon.vue'
import { assignmentSupportedFileMimes } from '@/helper/constants'
import { checkIcon } from '@/helper/constants'

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    folder: {
      type: String
    }
  },
  components: {
    Button,
    CircleComponent: Circle,
    BaseIcon
  },
  data() {
    return {
      checkIcon,
      showModal: false,
      uploading: false,
      files: [],
      uploadProgress: 0,
      fileDragged: false,
      uploadTaskCancelList: [],
      errorInUploading: false,
      fileExceedsMaxSize: false,
      errorMessage: ''
    }
  },
  methods: {
    closeModal() {
      this.cancelUpload()
      this.$emit('hide')
    },
    reset() {
      this.uploading = false
      this.files = []
      this.uploadProgress = 0
      this.fileDragged = false
      this.uploadTaskCancelList = []
      this.errorInUploading = false
      this.fileExceedsMaxSize = false
    },
    fileDragLeave(ev: any) {
      this.fileDragged = false
      ev.preventDefault()
      ev.stopPropagation()
    },
    fileDraggedOver(ev: any) {
      this.fileDragged = true
      ev.preventDefault()
      ev.stopPropagation()
    },
    fileDropped(ev: any) {
      console.log('files dropped')
      this.fileDragged = false
      ev.preventDefault()
      ev.stopPropagation()

      let files = []

      if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < ev.dataTransfer.items.length; i++) {
          // If dropped items aren't files, reject them
          if (ev.dataTransfer.items[i].kind === 'file') {
            files.push(ev.dataTransfer.items[i].getAsFile())
          }
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        files = ev.dataTransfer.files
      }

      if (files && files.length) {
        this.gotFiles(files)
      }
    },
    openFileDialog() {
      this.$refs.fileUpload.click()
    },
    fileSelected(event: any) {
      console.log('got file selected event --> ', event)
      const { files } = event.target

      this.gotFiles(files)
    },
    gotFiles(files) {
      this.errorMessage = ''
      this.fileExceedsMaxSize = false
      const allowedFiles = []

      files.forEach(file => {
        if (!assignmentSupportedFileMimes.includes(file.type)) {
          this.errorMessage = `${file.name} is not supported`
          return
        }

        if (!this.checkIfFileExceedsMaxSize(file.size)) {
          allowedFiles.push(file)
        } else {
          this.fileExceedsMaxSize = true
        }
      })

      if (allowedFiles && allowedFiles.length) {
        this.files = allowedFiles
        this.startUpload()
      }
    },
    async startUpload() {
      this.uploading = true
      this.errorInUploading = false

      const filesUploaded = [] as Array<UploadedFile>

      const totalFiles = this.files.length

      try {
        for (let i = 0; i < totalFiles; i++) {
          const file: any = this.files[i]
          const filename = file.name || `Untitled - ${new Date().getTime()}`

          const uploadedUrl = await this.uploadFile(file, filename, file.type, i)

          if (uploadedUrl) {
            const fileUpload = {
              url: uploadedUrl,
              title: filename,
              type: file.type,
              size: file.size
            } as UploadedFile
            filesUploaded.push(fileUpload)
          } else {
            console.error('File upload failed for --> ', filename)
          }
        }

        this.$emit('filesUploaded', filesUploaded)

        setTimeout(() => {
          this.$emit('hide')
        }, 2000)
      } catch (error) {
        console.error('Error while uploading file --> ', error)
        if (error && error.code === 'storage/canceled') {
          // user cancelled upload, no need to show error message
          Notice.warning({
            title: 'Upload cancelled!'
          })
        } else {
          this.errorInUploading = true
        }
      } finally {
        this.uploading = false
      }
    },
    async uploadFile(
      file: any,
      filename: string,
      fileType: string,
      fileIndex: number
    ): Promise<string | null> {
      const payload: any = { file, filename, type: file.type || fileType }

      if (this.folder) {
        payload['folder'] = this.folder
      }

      payload.progressUpdate = (currentProgress: number) => {
        this.uploadCompleted(fileIndex, currentProgress)
      }

      const {
        uploadPromise,
        cancelUpload
      } = await MediaUploadService.uploadFileToFirebaseStorage(payload)

      this.uploadTaskCancelList.push(cancelUpload)
      const { url } = await uploadPromise
      return url
    },
    uploadCompleted(filesDone: number, currentProgress: number) {
      const completed = 100 * filesDone + currentProgress
      const totalFiles = this.files.length
      this.uploadProgress = Math.floor(completed / totalFiles)
    },
    cancelUpload() {
      if (this.uploadTaskCancelList.length) {
        this.uploadTaskCancelList.forEach(element => {
          element()
        })
      }
      this.reset()
    },
    checkIfFileExceedsMaxSize(fileSize: number) {
      const maxFileSize = 50 //50mb
      const sizeInMB = (fileSize / 1024 / 1024).toFixed(2)

      return Number(sizeInMB) > maxFileSize
    }
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val

      if (val !== oldVal) {
        this.reset()
      }
    }
  }
})
